import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <p className="footer-names">Gabrielle &amp; Hugo</p>
        <p className="footer-date">04 septembre 2027 · Domaine de la Buritaz, Puidoux</p>
        <p className="footer-note">Fait avec amour pour notre grand jour 💛</p>
      </div>
    </footer>
  );
}

export default Footer;
